
import { PolicyComplianceDashboard } from '@/components/admin/policy-compliance/PolicyComplianceDashboard';

const PolicyComplianceAdmin = () => {
  return <PolicyComplianceDashboard />;
};

export default PolicyComplianceAdmin;
